<template lang='pug'>
  auth-layout
    #sign-up-phone.view
      bf-notice(:message='message' @close='message = ""')
      transition
        auth-body(v-show='show' key='auth-body')
          h5.heading {{ $t('Enter Phone Number Below to Receive Verification Code') }}
          bf-divider.section
          form.sign-up-form(v-show='!confirmed' @submit.prevent='sign_up')
            fieldset
              vue-tel-input.tel-input( required type='tel' :placeholder='$t("Phone Number")' v-model='phone' )
            bf-flex.space-between
              bf-button#back-button.large.tertiary.combo( @click.native='$router.go(-1)')
                template(v-slot:icon)
                  span.icon
                    back-icon
                template(slot='text') {{ $t('Back') }}
              bf-button#sign-in-button.large.combo.solid.submit(type='submit')
                template(v-slot:icon)
                  span.icon
                    sms-icon
                template(v-slot:text) {{ $t('Send Code') }}
              

          form.verify-form(v-show='confirmed' @submit.prevent='verify')
            bf-input
              template(slot='icon')
                password-icon
              input( required type='text' :placeholder='$t("SMS Verfication Code")' v-model='code' )

            bf-button#verify-button.large.combo.solid.submit(type='submit')
              template(slot='icon')
                span.icon
                  confirm-icon
              template(slot='text') {{ $t('Sign In') }}

      terms-policy
      auth-body.back-panel(v-show='show' key='back-panel')
</template>

<script>
  import { auth, firebase, db } from '@/main'
  import { Authenticable } from '@/mixins/authenticable'
  import AuthLayout from '@/layouts/auth'
  import VueTelInput from 'vue-tel-input'
  import AuthHeader from '@/components/auth-header'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'view.sign-up-phone',

    mixins: [ Authenticable, Animatable ],

    components: {
      AuthLayout,
      VueTelInput,
      AuthHeader,
      AuthBody,
      TermsPolicy
    },

    data() {
      return {
        phone: '',
        code: '',
        message: '',
        confirmed: null,
        credential: null,
        sent: { code: false },
        recaptchaVerifier: null,
        show: false,
        referral: {}
      }
    },

    methods: {
      sign_up() {
        firebase.auth().signInWithPhoneNumber( this.phone, this.recaptchaVerifier )
          .then( confirmationResult => {
            this.confirmed = confirmationResult
            this.message = this.$t('SMS verfication code has been sent.  Please enter the code below and sign in!')
          }).catch( e =>  this.message = e  )
      },

      verify() {
        this.confirmed.confirm( this.code ).then( result => {
          this.user = result.user
          this.credential = firebase.auth.PhoneAuthProvider.credential( this.confirmed.verificationId, this.code )
          
          let ref = db.collection( 'accounts' ).doc( result.user.uid )

          console.log('retrieving acc...')
          ref.get().then( snap => {
            if ( snap.exists ) {
              if ( this.welcomed( snap.data() ) ) this.$router.push({ name: 'welcome' })
              else this.$router.push({ name: 'new-profile' })
            }
            else {
              this.accountify( result )
              this.$router.push({ name: 'onboarding' })
            }
          })
        }).catch( e => this.message = e )
      }
    },

    mounted() {
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
        size: 'invisible',
        callback: function(response) {
          onSignInSubmit()
        }
      })
    },

    created() {
      if ( this.$route.params.id ) db.collection( 'customers' ).doc( this.$route.params.id ).get().then( doc => {
        this.phone = doc.data().phone
        this.referral = { id: doc.data().business_id }
      })
    }
  }

</script>

<style scoped lang='stylus'>
  .heading
    text-align center
    font-family 'Open Sans'

  .tel-input >>> .dropdown
    font-size .55em
    font-family Lato

  .bf-button
    margin-top 32px
    width 100%
    color var(--clr-light)
    border 0

  .sign-up-form
    #back-button
      margin-right 64px

  #verify-button
    margin 32px auto 0 auto
</style>
